import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetSetupTemplate } from "../queries/setupTemplates";
import { ENTITY } from "../constants";

export const SetupTemplateBreadcrumb = ({ match }) => {
  // Entity
  const { SETUPTEMPLATE } = ENTITY;

    const {
      data: setupTemplate,
      isLoading,
      isError,
      error,
    } = useGetSetupTemplate(match.params.setupTemplateId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (setupTemplate) {
      return <span>{trimString(setupTemplate[SETUPTEMPLATE.nameField], 20)}</span>;
    }
  
    return null;
  };